import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle, Heart } from 'lucide-react';
import { apiClient } from '../api';
import { useAuth } from '../context/AuthContext';

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const { refresh } = useAuth();
  const [status, setStatus] = useState('verifying'); // verifying | ok | fail
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setStatus('fail'); setError('Verification link is missing or malformed.'); return; }
    (async () => {
      try {
        const res = await apiClient.post('/auth/verify-email', { token });
        setEmail(res.data.email || '');
        setStatus('ok');
        refresh();
      } catch (err) {
        setStatus('fail');
        setError(err.response?.data?.detail || 'Verification failed');
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="min-h-screen bg-fnl-dark flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="relative">
            <span className="text-white font-bold text-3xl">F</span>
            <Heart className="absolute -top-1 -right-3 w-4 h-4 fill-fnl-pink text-fnl-pink" />
          </div>
          <span className="text-white font-semibold text-lg">Flirty</span>
        </Link>
        <div className="bg-fnl-purple/80 backdrop-blur rounded-2xl p-8 border border-purple-900/50 text-center">
          {status === 'verifying' && (
            <div data-testid="verify-pending">
              <div className="w-10 h-10 border-4 border-fnl-pink border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-purple-300">Verifying your email...</p>
            </div>
          )}
          {status === 'ok' && (
            <div data-testid="verify-success">
              <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-3" />
              <h2 className="text-2xl font-bold text-white mb-2">Email verified</h2>
              <p className="text-purple-300 text-sm mb-6">
                {email ? <><span className="text-white font-semibold">{email}</span> is now verified.</> : 'Your email is verified.'}
              </p>
              <Link to="/browse" className="inline-block px-6 py-3 bg-fnl-pink hover:bg-fnl-pink text-white font-semibold rounded-md btn-shadow-pink" data-testid="verify-continue">
                Continue to Flirty
              </Link>
            </div>
          )}
          {status === 'fail' && (
            <div data-testid="verify-fail">
              <XCircle className="w-14 h-14 text-red-400 mx-auto mb-3" />
              <h2 className="text-2xl font-bold text-white mb-2">Verification failed</h2>
              <p className="text-purple-300 text-sm mb-6">{error}</p>
              <Link to="/me" className="text-fnl-pink hover:underline font-semibold">Resend from My Profile →</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
